import React from 'react';
import { IconDocument } from "../icons";
import { Text } from "../text";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var getDefaultRejectedErrorPlainText = function getDefaultRejectedErrorPlainText(rejectedFiles, maxFiles) {
  return "Selected ".concat(rejectedFiles, " files while only ").concat(maxFiles, " allowed.");
};
export var defaultProps = {
  accept: '',
  cancelButtonText: 'Cancel',
  cancelUploadButtonTitle: 'Cancel upload',
  dragAndDropText: 'or drag and drop files',
  deleteFileButtonTitle: 'Delete file',
  errorText: 'There has been an error while uploading the files.',
  getUploadProgressAriaLabel: function getUploadProgressAriaLabel(file) {
    return "Progress for ".concat(file);
  },
  getUploadProgressSummary: function getUploadProgressSummary(uploadProgress) {
    return "".concat(uploadProgress, "% uploaded.");
  },
  isMulti: true,
  renderFileDetailsIcon: function renderFileDetailsIcon() {
    return ___EmotionJSX(IconDocument, {
      "aria-hidden": true,
      color: "neutral70"
    });
  },
  renderFileDetailsLabel: function renderFileDetailsLabel(file) {
    return ___EmotionJSX(Text, null, file.name);
  },
  renderRejectedErrorText: function renderRejectedErrorText(rejectedFiles, maxFiles) {
    return getDefaultRejectedErrorPlainText(rejectedFiles, maxFiles);
  },
  retryButtonText: 'Retry',
  showDropZone: true,
  showFileDetails: true,
  uploadButtonTitle: 'Upload file',
  uploadIconTitle: 'Upload',
  uploadProgressAriaLive: 'off'
};
export var FILE_UPLOAD_BLOCKS_SPACER_HEIGHT = 'S400';
export var FILE_UPLOAD_ERRORS_SPACING = 'S200';
export var FILE_DETAILS_BUTTON_SUB_ROW_MIN_WIDTH = '200px';
export var FILE_DETAILS_BUTTON_SUB_ROW_MIN_WIDTH_SMALL_VIEWPORT = '100%';
export var FILE_DETAILS_BUTTON_SUB_ROW_MIN_WIDTH_WITH_PROGRESS = '360px';